// extracted by mini-css-extract-plugin
module.exports = {"sm":"360px","smd":"830px","md":"1024px","slg":"1100px","lg":"1366px","xl":"1920px"};